var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h3',[_vm._v(_vm._s(_vm.$t("property_iq:tabs:legal")))]),_c('legal-status-app',{attrs:{"session_id":_vm.$store.state.sessionId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }